module.exports = __webpack_public_path__ + "static/media/Site2.70ce72e2.png";